<!-- TODO: THIS NEEDS TO BE FINISHED AND HOOKED UP TO THE REST OF THE FRONTEND -->

<template>
  <v-card 
    class="mx-auto"
  >
  <div v-if="!loading">
    <v-card-title>
      <b>{{ event.typeSpec == 1 ? 'Ενημέρωση καιρού' : 'Άλλο συμβάν'}} &nbsp;</b> στην περιοχή "{{ event.campName }}", στις {{ mktime(event.timestamp) }}
    </v-card-title>
    <v-card-text class="text-left">
      Θερμοκρασία / Temperature: {{ event.temperature }} °C <br />
      <br />
      Υγρασία / Humidity: {{ event.humidity }}% <br />
      <br />
      Ατμοσφ. Πίεση / Pressure: {{ event.pressure }} hPa <br />
      <br />
      Ταχύτητα Ανέμου(Μ.Ο. 1 λεπτού) / Wind Speed(1 min avg): {{ event.windSpeedOneMinAvg*3.6 }} km/h <br />
      <br />
      Ταχύτητα Ανέμου(Μ.Ο. 5 λεπτών) / Wind Speed(5 mins avg): {{ event.windSpeedFiveMinMax*3.6 }} km/h <br />
      <br />
      Κατεύθυνση Ανέμου / Wind Direction: {{ degToOrientation(event.windDirection) }} <br />
      <br />
      Ωριαία Βροχόπτωση / Hourly Rainfall: {{ event.rainfallOneHr }} mm <br />
      <br />
      Ημερήσια Βροχόπτωση / Daily Rainfall: {{ event.rainfallOneDay }} mm <br />

    </v-card-text>

    <v-spacer></v-spacer>

  </div>
  <v-progress-circular v-else indeterminate></v-progress-circular>

    <p class="font-weight-regular" style="color: red;">
      {{ error }}
    </p>

  </v-card>
</template>

<script>
// import Vue from 'vue';

export default {
  name: 'WeatherUpdateDetails',
  props: {
    eventId: {
      type: String,
      default: undefined,
      required: true
    }
  },
  data: () => {
      return {
          loading: true,
          event: {},
          sensor: {},
          confirmations: [],
          error: "",
          windOrientations: ['Β', 'ΒΑ', 'Α', 'ΝΑ', 'Ν', 'ΝΔ', 'Δ', 'ΒΔ']  //['Β', 'Α', 'Ν', 'Δ'] 
      }
  },
  async mounted() {
    await this.load()
  },
  watch: {
    async eventId() {
      await this.load()
    }
  },
  methods: {
    degToOrientation(oriDeg) {
      let n = this.windOrientations.length
      let bin_sz = 360/n

      // north is a special case
      if (oriDeg >= 360-bin_sz/2 || oriDeg < bin_sz/2) {
        return this.windOrientations[0]
      }

      // now we can handle everything else
      let low = bin_sz/2
      for (var i=1; i<n; i++) {
        low += bin_sz
        if (oriDeg < low) {
          return this.windOrientations[i]
        }
      }

      // if you reach this, something is wrong!
      return `Wind orientation error @ ${oriDeg}`
    },
    mktime(ts) {
      var dt = new Date(ts)
      dt.setTime(dt.getTime() - (new Date().getTimezoneOffset() * 60 * 1000))
      return dt.toLocaleString('el-GR')
    },
    async load(){
        if (this.eventId == undefined) {
          return
        }

        this.loading = true
        const query = {
            eventId: this.eventId
        }

        console.log('requesting from axios')
        try {
            var response = await this.$axios.get(`/weatherUpdates`, { params: {...query} })
            if (response.data && Object.keys(response.data).length === 0 && Object.getPrototypeOf(response.data) === Object.prototype) {
              return // no events
            }

            //loop through response data because for some reason it doesn't find the exact result from axios.
            var arrayLength = response.data.length
            for (var i = 0; i < arrayLength; i++){
              if (response.data[i].id == this.eventId){
                this.event = response.data[i]
                console.log(this.event)
                break
              }
            }

            response = await this.$axios.get('/weatherStations', { params: { id: this.event.sensorId } })
            this.sensor = response.data
            console.log(this.sensor)

            /*if (this.$store.state.user.isAdmin){
              response = await this.$axios.get(`/eventConfirmations/${this.event.id}`)
              this.confirmations = response.data
              console.log(this.confirmations)
            }*/


            this.error = ""
        } catch (e) {
            console.log(e.response.data)
            this.error = e.response.data
        }
        this.loading = false
      }
    }
}
</script>
